import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { EffectsModule } from '@ngrx/effects';

import { LinearBetslipModule } from '../linear/linear-betslip-module';
import BetslipDigitalPicksModule from '../picks/betslip-digital-picks.module';
import PickOddsModule from '../picks/pick-odds.module';
import { DigitalRewardTokensModule } from '../reward-tokens/digital-reward-tokens.module';
import BetslipDigitalSummaryModule from '../summary/betslip-digital-summary.module';
import BetslipDigitalValidationModule from '../validation/betslip-digital-validation.module';
import { LinearBetBuilderContentComponent } from './components/module/content/linear-bet-builder-content.component';
import { LinearBetBuilderHeaderComponent } from './components/module/header/linear-bet-builder-header.component';
import { LinearBetBuilderComponent } from './components/module/linear-bet-builder.component';
import { LinearBetBuilderPickErrorsComponent } from './components/module/pick/errors/linear-bet-builder-pick-errors.component';
import { LinearBetBuilderPickComponent } from './components/module/pick/linear-bet-builder-pick.component';
import { LinearBetBuilderPickContentComponent } from './components/module/pick/pick-content/linear-bet-builder-pick-content.component';
import { LinearBetBuilderPickSummaryComponent } from './components/module/pick/summary/linear-bet-builder-pick-summary.component';
import { LinearBetBuilderPickDisplayHeaderComponent } from './components/picks/header/linear-bet-builder-pick-display-header.component';
import { LinearBetBuilderWarningIndicatorComponent } from './components/picks/header/warning/linear-bet-builder-warning-indicator.component';
import { LinearBetBuilderPickDisplayComponent } from './components/picks/linear-bet-builder-pick-display.component';
import { LinearBetBuilderSelectionDisplayComponent } from './components/picks/selections/linear-bet-builder-selection-display.component';
import { LinearBetBuilderSelectionsListComponent } from './components/picks/selections/linear-bet-builder-selections-list.component';
import { LinearBetBuilderEffects } from './linear-bet-builder-effects';

@NgModule({
    imports: [
        CommonModule,
        AutomationModule,
        LinearBetslipModule,
        BetslipDigitalPicksModule,
        DigitalRewardTokensModule,
        PickOddsModule,
        BetslipDigitalSummaryModule,
        BetslipDigitalValidationModule,
        EffectsModule.forFeature([LinearBetBuilderEffects]),
        LinearBetBuilderWarningIndicatorComponent,
    ],
    providers: [],
    declarations: [
        LinearBetBuilderComponent,
        LinearBetBuilderHeaderComponent,
        LinearBetBuilderContentComponent,
        LinearBetBuilderPickComponent,
        LinearBetBuilderPickSummaryComponent,
        LinearBetBuilderPickDisplayComponent,
        LinearBetBuilderSelectionDisplayComponent,
        LinearBetBuilderPickDisplayHeaderComponent,
        LinearBetBuilderPickContentComponent,
        LinearBetBuilderSelectionsListComponent,
        LinearBetBuilderPickErrorsComponent,
    ],
    exports: [
        LinearBetBuilderComponent,
        LinearBetBuilderPickDisplayComponent,
        LinearBetBuilderSelectionsListComponent,
        LinearBetBuilderSelectionDisplayComponent,
        LinearBetBuilderPickComponent,
        LinearBetBuilderPickDisplayHeaderComponent,
    ],
})
export class LinearBetBuilderModule {}
